export default __webpack_public_path__ + "static/not_found_sad.f580cc78324443a9064a8266bb070657.jpg";